import { render } from "./MainHeadingNav.vue?vue&type=template&id=7f3f1b63&scoped=true"
import script from "./MainHeadingNav.vue?vue&type=script&lang=js"
export * from "./MainHeadingNav.vue?vue&type=script&lang=js"

import "./MainHeadingNav.vue?vue&type=style&index=0&id=7f3f1b63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f3f1b63"]])

export default __exports__